import { render, staticRenderFns } from "./app-token.vue?vue&type=template&id=9dd6ad66&"
import script from "./app-token.vue?vue&type=script&lang=js&"
export * from "./app-token.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports